<div style="background-color:#114B43;">
  <div class="container pt-4 pb-4">

    <fieldset style="background: #eee !important;">

      <form [formGroup]="PreContactForm" novalidate>
        <div class="container" style="background: #9cb93f;">
          <br>
          <h2 class="titlex">Creación de una cuenta de usuario</h2>
          <h5 class="titlex mb-2" *ngIf="allowInteract && !mensajes?.showTokenExpirado">Ingresa tus datos para crear una
            cuenta y acceder a Matrícula Online</h5>
        </div>

        <div class="row mt-2 mb-2 container" *ngIf="!allowInteract">
          <div class="col-md-12">
            <app-progress></app-progress>
          </div>
        </div>

        <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert"
          *ngIf="allowInteract && mensajes?.showTokenExpirado">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <label class="alert-heading">Estimado Postulante:</label>
          <p>{{ mensajes?.tokenExpirado }}</p>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
              style="background-color: #114B43!important; border-color:#114B43;" (click)="returnToLogin()">
              Ir al inicio
            </button>
          </div>
        </div>

        <div class="row mt-2 container" *ngIf="allowInteract && !mensajes?.showTokenExpirado">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-sm-6">
                <label class="font-weight-bold">Clave <span class="text-danger">*</span></label>
                <input type="password" class="form-control form-control-sm" placeholder="Clave Personal"
                  formControlName="Clave">
                <span class="text-muted"
                  *ngIf="!PreContactForm.controls['Clave'].valid && PreContactForm.controls['Clave']?.touched">
                  La contraseña debe cumplir con este formato:<br>
                  * letras mayúsculas y minúsculas. <br>
                  * Incluir caracteres (@ , . -) <br>
                  * números. <br>
                  * El largo de la clave debe ser de 8 a 16 caracteres.</span><br>
              </div>
              <div class="col-sm-6">
                <label class="font-weight-bold">Confirmacion Clave <span class="text-danger">*</span></label>
                <input type="password" class="form-control form-control-sm" placeholder="Confirmar Clave"
                  formControlName="Clave2">
                <span class="text-muted"
                  *ngIf="!PreContactForm.controls['Clave2'].valid && PreContactForm.controls['Clave2']?.touched">las
                  claves no son iguales</span>
              </div>
            </div>
          </div>
        </div>

        <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert"
          *ngIf="!mensajes?.showTokenExpirado && mensajes?.showErrorValidacion">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <label class="alert-heading">Estimado Postulante:</label>
          <p>{{ resultadoPreValidacionClave?.MensajeRetorno }}</p>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
              style="background-color: #114B43!important; border-color:#114B43;" (click)="returnToLogin()">
              Ir al inicio
            </button>
          </div>
        </div>

        <div *ngIf="allowInteract && !mensajes?.showTokenExpirado" class="row container mt-2 mb-2">
          <div class="col-md-12">
            <app-apibutton text="Ingresa tu clave para continuar registro" [progress]="progressValidacion"
              (click)="validarGuid()">
            </app-apibutton>
          </div>
        </div>
      </form>
    </fieldset>
  </div>
</div>
